export function newsFilter() {
    jQuery(document).ready(function ($) {
        var form = $("form.news-filter");
        form.on("change", `input[type="checkbox"]`, function () {
            form.submit();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/newsFilter.js